<script lang="ts">
    import { api } from '../../../stores/api';
    import { RouteTypeListApp } from './RouteTypeListApp';
    import { onMount } from 'svelte';
    import { RouteType } from './RouteType';
    import RouteTypeOne from './RouteTypeOne.svelte';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import { _ } from 'svelte-i18n';
    import { canWrite, writeDisabledTooltip } from '../../shared/Permissions/writeAccess';

    let rtla: RouteTypeListApp = new RouteTypeListApp($api);
    let routeTypes: RouteType[] = [];

    onMount(() => {
        Promise.all([rtla.getItems()]).then(response => {
            routeTypes = response[0];
        });
    });

    function onChange(routeType: RouteType) {
        rtla.updateOne(routeType);
        $NotificationSystem.reload();
    }
</script>

<div style="display: flex; row-gap: 10px; flex-direction: row; column-gap: 10px; flex-wrap: wrap;">
    {#each routeTypes as routeType, index (routeType.getId())}
        <!-- tooltip na obudowie: wyłączone pola nie łapią hovera, więc title musi siedzieć wyżej -->
        <div title={$canWrite ? '' : $_(writeDisabledTooltip)}>
            <RouteTypeOne {routeType} {onChange} />
        </div>
    {/each}
</div>
